import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useModal } from 'react-modal-hook';
import i18n from 'i18next';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { Button } from '../../../common/components/buttons';
import useStyles from './ClientList.styles';
import useAgent from '../../../common/hooks/useAgent';
import { Table } from '../../../table/components';
import { fullPageTableHeight } from '../../../table/components/Table';
import { Container } from '../../../common/components/layout';
import ConfirmationModal from '../../../common/components/modals/ConfirmationModal';
import clientAgent from '../../agents/clientAgent';
import { ContainerLoader } from '../../../common/components/loaders';

const ClientList = ({ onRowClick, onCreateClick }) => {
  const classes = useStyles();

  const [currentClient, setCurrentClient] = useState();

  const [deleteClient, deletedClient] = useAgent(clientAgent.deleteClient);
  const [fetchClients, clients, isFetchingClients] = useAgent(clientAgent.fetchClients);

  const [showModal, hideModal] = useModal(
    () => (
      <ConfirmationModal
        closeModal={hideModal}
        onCancelClick={hideModal}
        onConfirmClick={() => deleteClient(currentClient.id)}
        confirmButtonLabel={i18n.t('common.button.confirm')}>
        {i18n.t('client.message.deletionConfirmation')}
      </ConfirmationModal>
    ),
    [currentClient]
  );

  const handleDeleteClick = useCallback((callback) => {
    setCurrentClient(callback);
  }, []);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  useEffect(() => {
    if (currentClient) {
      showModal();
    }
  }, [currentClient, showModal]);

  useEffect(() => {
    if (deletedClient) {
      toast.success(i18n.t('common.message.success.deleted', { entity: 'client' }));
      fetchClients();
    }
  }, [deletedClient, fetchClients]);

  const { current: columns } = useRef([
    { Header: i18n.t('client.name'), accessor: 'name' },
    { Header: i18n.t('client.form.description'), accessor: 'description' },
  ]);

  const { current: rowActions } = useRef([{ icon: 'delete', onClick: handleDeleteClick }]);

  if (!clients || isFetchingClients) return <ContainerLoader />;

  return (
    <Container>
      <div className={classes.buttonContainer}>
        <Button primary onClick={onCreateClick}>
          {i18n.t('client.button.createClient')}
        </Button>
      </div>
      <div className={classes.table}>
        <Table columns={columns} data={clients} height={fullPageTableHeight} rowActions={rowActions} onRowClick={onRowClick} />
      </div>
    </Container>
  );
};

ClientList.propTypes = {
  onRowClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

ClientList.defaultProps = {
  onRowClick: undefined,
  onCreateClick: undefined,
};

export default ClientList;
